module.exports = __webpack_public_path__ + "img/NW10.11191f5b.gif";